import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, fallback = 'redirect' }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        if (fallback === 'blank') {
            return null;
        }
        return <Navigate to="/ambassador-login" replace />;
    }

    return children;
};

export default ProtectedRoute; 